import { React, useState } from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Button } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import { FaEdit } from "react-icons/fa";
import { globalinchtopointfactor } from "./AuxiliaryFunctions";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'12%'}}>Wall Name</th>
        <th style={{width:'5%'}}>Cabinet ID</th>
        <th style={{width:'12%'}}>Cabinet Name</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Size (WxHxD)</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Cabinet Type</th>
        <th className='d-none d-sm-table-cell' style={{width:'12%'}}>Cabinet config</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {

  if (props.wallsObj) {
    const rows = props.wallsObj.map((row, index) => { 
      const combined = [...row["rectangles"], ...row["wallrectangles"]];

      const cabs = combined.map((cabs, i) => {
        if (!cabs.cabinetConfig.includes("placeholder") && !cabs.cabinetConfig.includes("Adjacen")
    && cabs.cabinettype !== "appliances" && !cabs.cabinetConfig.includes("NoCornerCabinet")) {
          const depth = (cabs.cabinettype==="base_cabinet" || cabs.cabinettype==="tall_cabinet")?24:13;
          cabs.depth = depth;
          return (   
            <tr key={index}>        
              <td>
                {row.wallname}
              </td>          
              <td>
                {cabs.id}
              </td>
              <td>  
                {cabs.shapename}
              </td>       
              <td>  
                {cabs.width/globalinchtopointfactor + " x " + cabs.height/globalinchtopointfactor + " x " + cabs.depth}
              </td>   
              <td>  
                {cabs.cabinettype}
              </td>                                  
              <td>  
                {cabs.cabinetConfig}
              </td>
              
            </tr>
          )
        }
        else {
          return null;
        }
      });    
      return cabs;
    })

    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the patient.
  </Tooltip>
);



const KitchenCabinetsList = (props) => {  
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
          <TableHeader/>
            <TableBody wallsObj={props.walls}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

function DetailKitchenCabinets(props) { 
  const [lgShow, setLgShow] = useState(false);

  // This is how you make the current user available on any functional component
  //const { user } = useSelector(state => state.auth);

  const handleClose = () => setLgShow(false);
  const handleShow = () => {
    console.log(props.walls);
    setLgShow(true); 
  }
  return (
    <>
      <Button onClick={handleShow} className='ms-2' style={{maxWidth:"100px",maxHeight:'38px'}} variant="primary">{"Cabinets"}</Button>          
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            {'List of Cabinets in your Design'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <KitchenCabinetsList walls={props.walls} />
        </Modal.Body>

      </Modal>
    </>
  )
}

export default DetailKitchenCabinets;